import { Button, Grid, Typography } from "@mui/material"
import { MdOutlineCancel, MdOutlineReplay } from "react-icons/md";
import { useLocation, useNavigate } from "react-router-dom";
import useAuth from "../../../context/auth";
import { ClientsService } from "../../../services/clients";
import { useEffect } from "react";


export const OrderReproved = () => {
    const navigate = useNavigate()
    const { getData } = useAuth()
    const { state } = useLocation()

    const markAsRead = () => {
        ClientsService.markAsReadedContractReason(state?.id)
            .finally(() => {
                getData()
                navigate("/cliente", {
                    state: {
                        ignoreCanceled: true
                    }
                })
            })
    }

    useEffect(() => {
      console.log(state)
    }, [state])
    

    if (state?.description) {
        return (
            <Grid
                sx={{
                    height: "calc(100vh - 12.5rem)",
                    display: "flex",
                    flexDirection: "column",
                    gap: "2.5rem",
                    alignItems: "center",
                    justifyContent: "center"
                }}
            >
                <MdOutlineReplay size={142} color="#FE7B01" />
                <Typography fontWeight={700} fontSize={"3.2rem"} lineHeight={"4rem"} textAlign={"center"} color="#FE7B01">Houve um problema</Typography>

                <Typography fontWeight={400} fontSize={"1.6rem"} textAlign={"center"} mt={"-1.5rem"}>
                    Seu pedido não foi aprovado. <br/> Motivo da reprovação:
                </Typography>

                <Typography fontSize={"1.6rem"} sx={{ opacity: .5 }} textAlign={"center"}>{state?.description}</Typography>

                <Typography fontWeight={400} fontSize={"1.6rem"} textAlign={"center"} mt={"-1.5rem"}>
                    Corrija o problema acima e tente novamente.
                </Typography>
                <Button
                    variant="outlined"
                    sx={{
                        fontWeight: "500",
                        maxWidth: "32.7rem",
                        height: "5rem",
                        borderColor: "#79747E"
                    }}
                    onClick={markAsRead}
                >
                    Continuar
                </Button>

            </Grid>
        )
    }

    return (
        <Grid
            sx={{
                height: "calc(100vh - 12.5rem)",
                display: "flex",
                flexDirection: "column",
                gap: "3rem",
                alignItems: "center",
                justifyContent: "center"
            }}
        >
            <MdOutlineCancel size={142} color="#DA1717E5" />
            <Typography fontWeight={700} fontSize={"3.2rem"} lineHeight={"4rem"} textAlign={"center"} color="error">Solicitação não aprovada</Typography>

            <Typography fontWeight={400} fontSize={"1.6rem"} textAlign={"center"}>
                No momento não foi possível aprovar a sua solicitação.
                <br />
                Tente novamente após 180 dias.
            </Typography>

            <Button
                variant="outlined"
                sx={{
                    fontWeight: "500",
                    maxWidth: "32.7rem",
                    height: "5rem",
                    borderColor: "#79747E"
                }}
                onClick={markAsRead}
            >
                Finalizar
            </Button>

        </Grid>
    )
}